type Props = {
	active: boolean
}

export const ICON_FB = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="6"
			height="14"
			className={`icon ${props.active ? "active" : ""}`}
		>
			<path
				fill="#8D8D8D"
				fillRule="evenodd"
				d="M3.88 13.91V7.57h1.77l.26-2.48H3.88V3.51c0-.71.17-1.2 1.02-1.2h1.08V.1C5.8.07 5.15 0 4.4 0 2.84 0 1.77 1.15 1.77 3.27v1.82H0v2.48h1.77v6.34h2.11"
			/>
		</svg>
	);
};

export const ICON_HOME = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="12"
			className={`icon ${props.active ? "active" : ""}`}
		>
			<path
				fill="#8D8D8D"
				fillRule="nonzero"
				d="M6 0l6 4v8H7.9V7.99H4.1v4H0v-8z"
			/>
		</svg>
	);
};

export const ICON_LINK = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="8"
			className={`icon ${props.active ? "active" : ""}`}
		>
			<g fill="#8D8D8D" fillRule="nonzero">
				<path d="M5.19 5.9H3.66a2.24 2.24 0 010-4.48h1.53a.7.7 0 000-1.42H3.66a3.66 3.66 0 000 7.31h1.53a.7.7 0 000-1.42z" />
				<path d="M3.76 3.79c0 .3.24.55.54.55h4.8a.55.55 0 000-1.1H4.3c-.3 0-.54.25-.54.55z" />
				<path d="M9.76 0H8.22a.7.7 0 000 1.42h1.54a2.24 2.24 0 010 4.48H8.22a.7.7 0 000 1.41h1.54a3.66 3.66 0 000-7.31z" />
			</g>
		</svg>
	);
};

export const ICON_LINKEDIN = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="12"
			className={`icon ${props.active ? "active" : ""}`}
		>
			<path
				fill="#8D8D8D"
				fillRule="evenodd"
				d="M3 4.36V12H0V4.36h3zm5.98-1.09C10.71 3.27 12 4.5 12 7.11V12H9.38V7.44C9.38 6.29 9 5.5 8.05 5.5c-.72 0-1.15.53-1.34 1.04-.07.18-.09.43-.09.69V12H4s.03-7.73 0-8.53h2.62v1.21c.35-.58.97-1.4 2.36-1.4zM1.51 0C2.42 0 2.98.7 3 1.64c0 .9-.58 1.63-1.5 1.63h-.03C.57 3.27 0 2.55 0 1.64 0 .7.6 0 1.5 0z"
			/>
		</svg>
	);
};

export const ICON_MAIL = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="9"
			className={`icon ${props.active ? "active" : ""}`}
		>
			<path
				fill="#8D8D8D"
				fillRule="nonzero"
				d="M1.18 0H12.7c.32 0 .61.12.84.31L7 5.31.46.31C.66.14.9.03 1.18 0zm12.8 1.1c.03 1.94.01 4.38.01 6.34 0 .73-.57 1.31-1.3 1.31H1.32A1.3 1.3 0 010 7.45L.01 1.1l6.7 5.13c.16.14.42.14.57 0l6.7-5.14z"
			/>
		</svg>
	);
};

export const ICON_PUSH = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="12"
			className={`icon ${props.active ? "active" : ""}`}
		>
			<g fill="#8D8D8D" fillRule="nonzero">
				<path d="M6 0a6 6 0 100 12A6 6 0 006 0zm0 11.05A5.05 5.05 0 116 .95a5.05 5.05 0 010 10.1z" />
				<path d="M6 2.73a3.27 3.27 0 100 6.54 3.27 3.27 0 000-6.54z" />
			</g>
		</svg>
	);
};

export const ICON_TWITTER = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="11"
			className={`icon ${props.active ? "active" : ""}`}
		>
			<path
				fill="#8D8D8D"
				fillRule="evenodd"
				d="M6.82 2.65c0 .2.03.41.07.6A8.4 8.4 0 01.97.5C.73.88.6 1.33.6 1.82c0 .92.5 1.73 1.27 2.2a3.04 3.04 0 01-1.3-.33v.04c0 1.28 1 2.35 2.3 2.6a3.1 3.1 0 01-1.3.04 2.86 2.86 0 002.7 1.84A6.08 6.08 0 010 9.31a8.63 8.63 0 004.4 1.19c5.29 0 8.18-4.04 8.18-7.54l-.01-.34A5.61 5.61 0 0014 1.24c-.52.21-1.07.36-1.65.42A2.7 2.7 0 0013.61.19c-.55.3-1.17.53-1.82.65A2.98 2.98 0 009.69 0C8.11 0 6.82 1.19 6.82 2.65z"
			/>
		</svg>
	);
};

export const ICON_YOUTUBE = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="10"
			className={`icon ${props.active ? "active" : ""}`}
		>
			<path
				fill="#8D8D8D"
				fillRule="nonzero"
				d="M11.63 0H2.37A2.4 2.4 0 000 2.42v5.05a2.4 2.4 0 002.37 2.41h9.26A2.4 2.4 0 0014 7.47V2.42A2.4 2.4 0 0011.63 0zm-3.8 6.18L5.75 7.4V2.47l2.06 1.24 2.06 1.23-2.06 1.24z"
			/>
		</svg>
	);
};

export const ICON_BOOSTED = (props: Props) => {
	return (
		<svg 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			height="11" width="11" version="1.1" id="Layer_1" viewBox="0 0 512 512" xmlSpace="preserve"
			className={`icon ${props.active ? "active" : "hidden"}`}>
			<path fill="#8D8D8D" d="M95.998,418.909H76.22c-25.706,0-46.545,20.84-46.545,46.545C29.674,491.16,50.514,512,76.22,512  h66.324h188.509c83.413,0,151.273-67.86,151.273-151.273c0-40.609-16.088-77.528-42.22-104.727  c26.132-27.2,42.22-64.118,42.22-104.727C482.326,67.86,414.466,0,331.053,0H142.544H76.22C50.514,0,29.674,20.84,29.674,46.545  s20.84,46.545,46.545,46.545h19.779V256V418.909z M189.089,93.091h141.964c32.082,0,58.182,26.1,58.182,58.182  s-26.1,58.182-58.182,58.182H189.089L189.089,93.091L189.089,93.091z M189.089,302.545h141.964c32.082,0,58.182,26.1,58.182,58.182  s-26.1,58.182-58.182,58.182H189.089L189.089,302.545L189.089,302.545z"/>
			<path fill="#8D8D8D" d="M189.089,418.909V302.545H256v-93.091h-66.911V93.091H256V0H142.544H76.22  C50.514,0,29.674,20.84,29.674,46.545s20.84,46.545,46.545,46.545h19.779V256v162.909H76.22c-25.706,0-46.545,20.84-46.545,46.545  C29.674,491.16,50.514,512,76.22,512h66.324H256v-93.091H189.089z"/>
		</svg>
	)
}